import Chifam from './Chifam'
import Home from './Home'
import Login from './Login'

export * from './store'

export default [Home, Login, Chifam]
